import axiosInstance from "./AxiosInstance";

export function getfaqTagsApi(){
    return axiosInstance.get('api/faq/tags/')
}

export function createfaqApi(data){
    return axiosInstance.post('api/faqs/',data)
}

export function getfaqApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/faqs/?${fparam}`)
}

export function updatefaqApi(id,data){
    return axiosInstance.patch(`api/faq-detail/${id}/`,data)
}

export function getfaqDetailsApi(id){
    return axiosInstance.get(`api/faq-detail/${id}/`)
}

export function FaqDeleteApi(id){
    return axiosInstance.delete(`api/faq-detail/${id}/`)
}